import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import useSeedLessonShellCache from '@/data/hook/lesson-progress/useSeedLessonShellCache';
import useInfiniteService from '@/data/hook/useInfiniteService';
import { studentDashboardQueries } from '@/data/query-keys/studentDashboardQueryKey';
import unitLessonProgressesQueryFilters from '@/utils/lesson-progress/unitLessonProgressesQueryFilters';

type UseUnitLessonProgressesParams = {
  courseProgressId: number;
  unitId: number;
};

export default function useUnitLessonProgresses({
  courseProgressId,
  unitId,
}: UseUnitLessonProgressesParams) {
  const service = useInfiniteService({
    ...studentDashboardQueries.lessonProgressesInfinite(
      unitLessonProgressesQueryFilters({ courseProgressId, unitId }),
    ),
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  useSeedLessonShellCache({
    courseProgressId,
    lessonProgresses: service.results,
  });

  // TODO: read completed/total from the API once the backend exposes per-unit counts
  const completedLessons = service.results.filter(
    ({ progress }) => progress >= 1,
  ).length;
  const totalLessons = service.meta?.pagination.count;

  return { ...service, completedLessons, totalLessons };
}
